import { createRouter, createWebHistory } from 'vue-router'

// 定义路由
const routes = [
  {
    path: '/',
    meta: { title: '首页-星遇互游,让直播更简单' },
    component: () => import('../layout/MainLayout.vue'),
    children: [
      {
        path: '',
        redirect: '/home',
      },
      {
        path: '/home',
        meta: { title: '首页-星遇互游,让直播更简单' },
        component: () => import('../views/Home.vue'),
      },
      {
        path: '/bigo',
        meta: { title: 'bigo-星遇互游,让直播更简单' },
        component: () => import('../views/GameCenterBigo.vue'),
      },
      {
        path: '/game-center',
        meta: { title: '游戏中心-星遇互游,让直播更简单' },
        component: () => import('../views/GameCenter.vue'),
      },
      {
        path: '/im-chat',
        meta: { title: 'IM聊天-星遇互游,让直播更简单' },
        component: () => import('../views/IMChat.vue'),
      },
      {
        path: '/consult',
        meta: { title: '星遇咨询-星遇互游,让直播更简单' },
        component: () => import('../views/StalConsult.vue'),
      },
    ],
  },
]

// 创建router实例
const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title || '默认标题'
  next()
})

export default router
